import React from 'react';
import { Button } from '../Button/Button';

interface Props {
  onZoomIn: () => void;
  onZoomOut: () => void;
}

export function ZoomControl({ onZoomIn, onZoomOut }: Props): JSX.Element {
  return (
    <div className="seatmap__zoom-control">
      <Button elevated icon="plus" onClick={onZoomIn} />
      <Button elevated icon="minus--sm" onClick={onZoomOut} />
    </div>
  );
}
